/**
 * EMİR #95.1 — kota metni: SÜREDEN türer, takvimden DEĞİL.
 *
 * ⚠️ Eski metin ("Bugünlük kutu açma sınırına ulaştın") takvim-günü sayacına
 * göre DOĞRUYDU: sayaç gece yarısı sıfırlanıyordu, yani gerçekten "bugünlük"tü.
 * Kayan pencerede aynı cümle YALAN olur — kota yarın değil, en eski kova
 * pencereden düşünce açılır (bu 7 dakika da olabilir). Bu yüzden pencere
 * göçünün AYRILMAZ parçası: sunucu `retryAfterMs` gönderir, metin ondan türer.
 *
 * Süre YOKSA (bayrak kapalı, eski takvim yolu) eski metin doğruluğunu korur ve
 * aynen kullanılır — iki mod da kendi gerçeğini söyler.
 *
 * ⚠️ Fonksiyonlar tarafındaki eşi: `functions/src/shared/kayanPencere.ts`
 * `yenidenDenemeMetniTR`. İki taraf ortak modül paylaşmıyor (ayrı derleme
 * hedefleri) → metin sözleşmesi `src/utils/kotaMesaji.test.ts` ile kilitli.
 */

/** ms → "45 dakika sonra" / "3 saat sonra". 0/negatif → en az 1 dakika. */
export function yenidenDenemeSuresiTR(retryAfterMs: number): string {
  const dk = Math.max(1, Math.ceil(Math.max(0, retryAfterMs) / 60_000));
  if (dk < 60) return `${dk} dakika sonra`;
  return `${Math.ceil(dk / 60)} saat sonra`;
}

/**
 * Genel limit mesajı (takip/beğeni/yorum…). Sunucu metni GELMİŞSE o kullanılır
 * — sunucu zaten süreden türetiyor ve etiketi (Takip/Beğeni…) biliyor.
 * Sunucu metni yoksa süreye düşülür; süre de yoksa takvim cümlesi (o modda doğru).
 *
 * ⚠️ Sıra kasıtlı: sunucu metnini EZERSEK, sunucudaki etiket bilgisini kaybeder
 * ve iki taraf ayrı cümleler üretmeye başlar (aynı sorunun iki kaynağı).
 */
export function limitMesajiTR(
  sunucuMetni: string | undefined | null,
  etiket: string,
  retryAfterMs?: unknown,
): string {
  const s = String(sunucuMetni || "").trim();
  if (s) return s;
  const ms = typeof retryAfterMs === "number" ? retryAfterMs : NaN;
  if (Number.isFinite(ms) && ms >= 0) {
    return `${etiket} limitine ulaştın. ${yenidenDenemeSuresiTR(ms)} tekrar deneyebilirsin.`;
  }
  return `Bugünlük ${etiket.toLocaleLowerCase("tr")} limitine ulaştın. Yarın tekrar dene.`;
}

/**
 * Kutu tavanı mesajı.
 * @param retryAfterMs sunucudan gelen süre (`HttpsError.details.retryAfterMs`).
 *                     Yoksa/geçersizse takvim metnine düşer.
 */
export function kutuTavaniMesajiTR(retryAfterMs?: unknown): string {
  // ⚠️ `Number(null) === 0` — TÜR KONTROLÜ ŞART. Sayıya çevirseydik alanın
  // YOKLUĞU (null) "0 ms" olur ve "1 dakika sonra" diye YANLIŞ bilgi verirdik;
  // testin yakaladığı gerçek kusur buydu. Varlık/yokluk belirsizliği metne
  // giremez (95.3'teki `undefined` çökertme kararının aynısı, UI ekseninde).
  const ms = typeof retryAfterMs === "number" ? retryAfterMs : NaN;
  if (Number.isFinite(ms) && ms >= 0) {
    return `Kutu açma sınırına ulaştın. ${yenidenDenemeSuresiTR(ms)} tekrar deneyebilirsin.`;
  }
  return "Bugünlük kutu açma sınırına ulaştın.";
}
